module.exports = __webpack_public_path__ + "static/media/icon_empty_data.e0276177.svg";